<template>
    <el-container>
    <!--<iframe data-index="1" sandbox="allow-scripts allow-forms allow-same-origin" class="object-main" style="height: 350px; width: 100%;"
        src="https://ai.aikan8.com/index.html?acid=6444&amp;click=56562&amp;day=0" type=""></iframe>-->
        <!-- 头部 -->
        <div class="app1">
           <div class="app2">
             <div class="stayl-1">
               <img src="../assets/img1/图片一.png" alt="">
             </div>
             <div class="stayl-2" >
                <div>
                    <div class="num1">
                        <div style="width: 140px;height: 40px; margin-top: 28px;margin-left: 30px;"><img src="../assets/img1/2.png" alt=""></div>
                        <div style="margin-left: 200px;margin-top: -46px;">
                                <h4>{{tuAde.click}}次</h4>
                        </div>
                    </div>
                    <div class="num2">
                        <div style="width: 140px;height: 40px; margin-top: 28px;margin-left: 30px;"><img src="../assets/img1/1.png" alt=""></div>
                        <div style="margin-left: 200px;margin-top: -46px;">
                            <h4>{{tuAde.time}}天</h4>
                        </div>
                    </div>
                </div>
             </div>
             <div class="stayl-3">
                 <div class="num3">
                     <div style="margin-left: 25px;margin-top: 12px;">
                        <h2>排名：首页</h2>
                     </div>
                     <div style="margin-left: 150px;margin-top: -30px;margin-right: 20px;"><img src="../assets/img1/3.png" alt=""></div>
                 </div>
                 <div class="num4">
                    <div style="margin-left: 25px;margin-top: 12px;">
                        <h2>排名：首页</h2>
                    </div>
                    <div style="margin-left: 150px;margin-top: -30px;margin-right: 20px;"><img src="../assets/img1/4.png" alt=""></div>
                 </div>
                 <div class="num5">
                    <div style="margin-left: 25px;margin-top: 12px;">
                        <h2>排名：首页</h2>
                    </div>
                    <div style="margin-left: 150px;margin-top: -30px;margin-right: 20px;"><img src="../assets/img1/5.png" alt=""></div>
                 </div>
             </div>
             <div class="stayl">
               <img src="../assets/img1/图片二.png" alt="">
            </div>
             <div class="app">
               <video class="video" src="../assets/sping/08.mp4" autoplay="autoplay" 
               loop="loop" muted>
				  
				</video>
             </div>
           </div>
        </div>
        <div class="banner" v-loading="loadingAd" v-if="is_show">
            <el-carousel height="70px" arrow="hover" direction="vertical" indicator-position="none">
                <el-carousel-item v-for="item in adList" :key="item.adv_id" :style="{ backgroundColor: item.background }">
                    <el-image :src="$img(item.adv_image)" fit="cover" @click="$router.pushToTab(item.adv_url.url)" />
                </el-carousel-item>
            </el-carousel>
            <i class="el-icon-circle-close" @click="closeAd"></i>
        </div>
        <el-header><ns-header /></el-header>
        <el-main>
            <transition name="slide"><router-view /></transition>

            <!-- 右侧栏 -->
            <ns-aside />
        </el-main>
        <!-- 底部 -->
        <el-footer><ns-footer /></el-footer>
    </el-container>
</template>
<script type="text/javascript">
     //var video=document.getElementById("video"); 
     //video.controls=false;
</script>
<script>
    import NsHeader from "./components/NsHeader"
    import NsFooter from "./components/NsFooter"
    import NsAside from "./components/NsAside"
    import { adList } from "../api/website"
    import Utils from "../utils/config.js"
    //import axios from "axios"
   //const requestUrl="http://lzrh.ands-gov.com"
    export default {
        name: "Layout",
        components: {
            NsHeader,
            NsFooter,
            NsAside
        },
        created() {
            this.getAdList()
        },
        data: () => {
            return {
                loadingAd: true,
                adList: [],
                is_show: true,
                indexTopAdNum: 0,
                //储存获取到的数据
                tuAde: []
            }
        },//axios数据请求
        mounted() {
           this.axios({
           //url: 'http://lzrh.ands-gov.com/api/addon/SetApi',
            url:Utils.baseUrl+"/api/addon/SetApi",
            method:'post',
        }).then(res => {
            this.tuAde=res.data
            //console.log(url) 
            }) 
        },
       
        computed: {},
        watch: {},
        methods: {
           
            getAdList() {
                if (this.$store.state.app.indexTopAdNum >= 3) {
                    this.loadingAd = false
                    this.is_show = false
                    return
                }
                adList({ keyword: "NS_PC_INDEX_TOP" })
                    .then(res => {
                        this.adList = res.data.adv_list
                        for (let i = 0; i < this.adList.length; i++) {
                            if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
                        }
                        this.loadingAd = false
                    })
                    .catch(err => {
                        this.loadingAd = false
                    })
            },
            closeAd() {
                this.is_show = false
                this.indexTopAdNum = this.$store.state.app.indexTopAdNum
                this.indexTopAdNum++
                this.$store.commit("app/SET_INDEXTOPADNUM", this.indexTopAdNum)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .banner {
        text-align: center;
        height: 70px;
        position: relative;
        i {
            font-size: 30px;
            position: absolute;
            z-index: 100;
            right: 280px;
            top: 10px;
            cursor: pointer;
            color: #d4d4d4;
        }
    }
    .el-header {
        padding: 0;
        height: 180px !important;
    }
    .el-footer {
        padding: 0;
        height: auto !important;
        background-color: #fff;
        padding-top: 45px;
    }
    *{
        padding: 0px;
        margin: 0px;
    }
    .app1{
        width: 100%;
        height: 350px;
        /*background: linear-gradient(68deg,rgb(13, 8, 87) 0%,rgb(179, 120, 72) 100%);*/
        /*添加浮动*/
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .app2{
        width: 1300px;
        height: 350px;
        /*background-color: aquamarine;*/
    }
    .stayl-1{
        width: 250px;
        height: 250px;
        /*background-color: blueviolet;*/
        position: absolute;
        top: 45px;
        animation: alternate-container 3s linear infinite;
    }
    @keyframes alternate-container{
       0%{
           transform: rotate(0deg);
       }
       100%{
           transform: rotate(360deg);
       }
    }
    .stayl-2{
        width: 340px;
        height: 194px;
        margin-left: 300px;
        margin-top: 78px;
       
    }
    .stayl-3{
        width: 340px;
        height: 194px;
        margin-left:640px;
        margin-top: -194px;
    }
    .stayl{
        width: 100px;
        height: 100px;
        margin-top: -145px;
        margin-left:75px ;
    }
    .num1{
        width: 340px;
        height: 88px;
        background-color: rgb(31, 111, 230,0.2);
        border: 1px solid rgb(49, 195, 231);
        box-shadow: 0px 0 0 #f1e3e3 inset, 0 0 5px #5dfaff;
    
    }
    .num2{
        width: 340px;
        height: 88px;
        background-color: rgb(31, 111, 230,0.2);
        margin-top: 20px;
        border: 1px solid rgb(49, 195, 231);
        box-shadow: 0px 0 0 #f1e3e3 inset, 0 0 5px #5dfaff;
    
    }
    .num3{
        width: 310px;
        height: 54px;
        background-color: rgb(31, 111, 230,0.2);
        margin-left: 20px;
        border: 1px solid rgb(49, 195, 231);
        box-shadow: 0px 0 0 #f1e3e3 inset, 0 0 5px #5dfaff;
    
    }
    .num4{
        width: 310px;
        height: 54px;
        background-color: rgb(31, 111, 230,0.2);
        margin-left: 20px;
        margin-top: 16px;
        border: 1px solid rgb(49, 195, 231);
        box-shadow: 0px 0 0 #f1e3e3 inset, 0 0 5px #5dfaff;
    
    }
    .num5{
        width: 310px;
        height: 54px;
        background-color: rgb(31, 111, 230,0.2);
        margin-left: 20px;
        margin-top: 16px;
        border: 1px solid rgb(49, 195, 231);
        box-shadow: 0px 0 0 #f1e3e3 inset, 0 0 5px #5dfaff;
    }
    h4{
        font-size: 26px;
        color:#fff;
        font-weight: 100;
    }
    h2{
        font-size: 18px;
        color:#fff;
        font-weight: 100; 
    }
    .app{
        width: 300px;
        height: 480px;
        /*background-color: blueviolet;*/
        margin-left: -305px;
        margin-top: -200px;
        position: absolute;
        z-index: -1;
        /*max-width: 800%;*/
    }
    /*video::-webkit-media-controls-fullscreen-button{
     display: none!important
}*/
   .video{
       width: 2090px;
       height: 350px ;
       margin-top: -30px;
       margin-left: -83px;
   }
</style>
